export default __webpack_public_path__ + "static/media/heartRed.616f373a.svg";